import * as React from 'react';
import { Wrapper, PlayerDiv } from './styles';

export class PrimisMain extends React.Component {
	// mPrimis;
	render() {
		return (
			<Wrapper>
				<PlayerDiv id="FreeStarVideoAdContainer">
					<div id='freestar-video-parent'>
						<div id='freestar-video-child'></div>
					</div>
				</PlayerDiv>
			</Wrapper>
		);
	}
}